// extracted by mini-css-extract-plugin
export default {"campaignEntryWrapper":"CampaignEntry_campaignEntryWrapper__sx+Du","submitContainer":"CampaignEntry_submitContainer__fTrng"};